import { render, staticRenderFns } from "./CompanyIcon.vue?vue&type=template&id=82dd82be"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82dd82be')) {
      api.createRecord('82dd82be', component.options)
    } else {
      api.reload('82dd82be', component.options)
    }
    module.hot.accept("./CompanyIcon.vue?vue&type=template&id=82dd82be", function () {
      api.rerender('82dd82be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CompanyIcon.vue"
export default component.exports